export const environment = {
  /**production o staging builds */
  production: import.meta.env.NG_APP_ENV === 'production' || import.meta.env.NG_APP_ENV === 'staging',
  /** production | staging | development */
  env: `${import.meta.env.NG_APP_ENV}`,
  baseUrl: `${import.meta.env.NG_APP_FRONTEND}`,
  googleMapsApiKey: `${import.meta.env.NG_APP_GOOGLE_MAPS_API_KEY}`,
  graphqlEndpoint: `https://${import.meta.env.NG_APP_BACKEND}/graphql`,
  websocketEndpoint: `wss://${import.meta.env.NG_APP_BACKEND}/subscriptions`,
  serverClientId: `${import.meta.env.NG_APP_SERVER_CLIENT_ID}`,
  ipApiKey: `${import.meta.env.NG_APP_IP_API_KEY}`,
  gtag: `${import.meta.env.NG_APP_GTAG}`,
  glitchtipKey: `${import.meta.env.NG_APP_GLITCHTIP_KEY}`,
  glitchtipKeyServer: `${import.meta.env.NG_APP_GLITCHTIP_KEY_SERVER}`,
  stripeKey: `${import.meta.env.NG_APP_STRIPE_KEY}`,
  traceRouterScrolling: false,
  showBannerTripBusiness: false,
  showPaladin: false,
};
